// import socketio from "socket.io-client";
import { io } from "socket.io-client";
import React from 'react';

export const socket = io("/",
    {
        // http://localhost:8080/
        path: '/websocket',
        // transports: ['websocket']
        // transports: ["websocket" , "polling"]
        // transports: ["polling" , "websocket"]
        
        
        // forceNew:true,
        
        // upgrade: false,
        // transports: ["websocket"],
    });
socket.on('connect', () => {
    console.log(`I'm connected with the back-end`);
    console.log(socket.id);

    const transport = socket.io.engine.transport.name; // in most cases, "polling"
    // console.log("transport : " , transport);

    socket.io.engine.on("upgrade", () => {
        const upgradedTransport = socket.io.engine.transport.name; // in most cases, "websocket"
        // console.log("upgradedTransport : " , upgradedTransport);
      });

      socket.on("connect_error", (err) => {
        console.log(`connect_error due to ${err.message}`);
      });
});
socket.on("connect_error", (err) => {
    console.log(`connect_error due to ${err.message}`);
  });
export const SocketContext = React.createContext();
